// Stable universal identifiers for eWings entities (all UUID v4).
// Never change these once synced: the server matches entities by these IDs.

export const STUDENT_LEAD_OBJECT_ID = '7b33cf72-28ae-4eb7-9eb8-fe20569aa088';
export const STUDENT_LEAD_FIELD_IDS = {
  name: '9dfc3087-9a15-4f60-af25-546b0e908f01',
  phone: '320cd7d6-a53b-4495-b113-cf6d2da32d71',
  email: 'e060241a-6c5d-4dad-9aa9-51839a9ebfd3',
  neetQualified: '8dd22a8f-3845-4e3f-b16f-9887ff8781da',
  neetScore: '04330fc4-425d-49b4-a63e-c4642a6571cb',
  state: 'f982e596-7ac9-4170-b4bc-2c6217378bb6',
  budget: '2c799321-ada4-4863-9219-93990abb6182',
  preferredCountry: '1bb3ad5b-dfc2-4355-9c12-42263e439c88',
  intake: 'be9ce6a6-6a79-4914-8f64-e3ef4f2629f6',
  stage: '01e5584a-8bc8-4f02-9a2c-b1fca77814f8',
  leadSource: 'e9b3d404-e263-4b15-bcb4-372cafb3893a',
  notes: 'e5b1b99a-a6ed-49fd-9404-58b341133438',
  leadScore: 'cc2acd41-5d9b-4a52-a506-81fa46bce48a',
  priority: 'c7739012-26dc-4883-8858-543c92989af8',
  counsellingSessions: 'fac1a6d8-dfda-4431-81d9-ba68b25bc630',
  callInterestScore: 'b41e7c92-08d5-4a63-9e17-2c8f4a1d6b30',
  callTemperature: 'a97d2f14-5e8b-4c06-bd39-71ea3c5f08b2',
  lastCallAnalysedAt: '6c3b8ea0-d419-4f72-8a51-93d0b7e2c45f',
  reminders: '8f1f94df-fdaa-4420-8dbc-3e26b0f4ea37',
  documents: 'bf11666e-1c39-460e-a69d-914ac9fdde32',
  // Lead Desk: who owns the student and when the next call is due.
  parentName: '3df46489-3529-482d-829c-b368c1625d8b',
  alternatePhone: '6f123db4-4a60-40ec-a4f3-5979b7650b4f',
  city: '7bcc3252-fce9-4124-ab03-04ecd1f8e63a',
  district: 'c0ebaedb-e06e-404b-a88d-008205f20439',
  streetAddress: '06947f7a-3a37-4475-b22d-7c33063726ef',
  counsellorName: '9c16e859-6dac-4be7-86ff-66de68fad693',
  telecallerName: '7725537d-aa9c-46b2-bd72-4c3a37a4ed57',
  nextCallAt: '6d06773a-d46e-4254-ae8c-899c8a7b8d29',
  followUpStatus: '30fa01ec-4475-49c1-b7f6-1f16fd17af59',
  isBlocked: 'f183a5e4-7b56-41d9-ad14-d76556f4b643',
  deskStatus: 'f0469030-407b-4f19-b983-6b94d5b9c73b',
  isPotential: '7c51c3e5-a0d6-44e6-bdeb-e994cec325d4',
} as const;

export const COUNSELLING_SESSION_OBJECT_ID = 'e0a8551e-d61b-4007-a620-0c40f360f890';
export const COUNSELLING_SESSION_FIELD_IDS = {
  name: '028e56ac-003b-4e64-a9ad-ff0b2a789735',
  sessionDate: 'fdfc9e1e-a6d2-46c6-8a9c-b7e78d976cbb',
  status: 'e8b5a41c-433b-46ee-92ae-897e91b970e0',
  counsellor: '3f14c2f2-b7dc-4980-8c03-d7b000cbf283',
  sessionType: '559b499a-4244-413a-9171-462fde23bc64',
  summary: '3e9bd744-98a8-40da-8087-b3307224fe31',
  studentLead: 'f5c81d85-6992-4755-8fe3-e75218ab8d47',
  transcript: '7a2f5c18-93b4-4e06-a1d7-58c9e2b40f63',
  transcriptPreview: 'c85d1b74-2e60-4f39-9a02-1d47b6e85c90',
  callDurationSeconds: '4e19a36f-7c85-4b21-93de-0a7f2c61d859',
  callPhoneNumber: '9b6c04e2-58a1-4d73-bf60-3e825a9d71c4',
} as const;

export const UNIVERSITY_OBJECT_ID = '6fe72986-2beb-4454-ac97-de605f572ab4';
export const UNIVERSITY_FIELD_IDS = {
  name: '3737cd14-f442-4002-b351-6626ec399487',
  country: 'ebaa5959-d1b7-4435-8a45-40063676723e',
  tuitionFee: 'dabffc74-b80d-49e8-8728-697596a81b7a',
  hostelFee: '9b93b842-9e15-4fad-b041-824b21463afc',
  nmcStatus: 'efee15f4-fd63-47eb-979d-375ba6036b98',
  mediumOfInstruction: 'b3304662-8aba-4229-b631-3649457be0f6',
  whoRanking: '33d281fa-c21b-478a-92f3-a534c91962cd',
  eligibility: '6d2f85c0-a9bc-4c40-a739-5d47360c972d',
} as const;

export const KNOWLEDGE_BASE_ENTRY_OBJECT_ID = 'b2c9905e-5d1c-4a04-bd72-1f6dd115d95d';
export const KNOWLEDGE_BASE_ENTRY_FIELD_IDS = {
  question: 'dc307705-cd53-442e-9dac-a4639037f7e4',
  category: 'df9f6a27-d45d-420d-804d-c5d3a367775c',
  response: 'b093c0d5-4140-4d92-a342-f4e9550061d7',
  priority: 'a3d80220-bdc4-42a2-974b-614ac7558892',
  source: '5564ce75-1758-446b-95f4-0483756d6aaf',
} as const;

export const LOGIC_FUNCTION_IDS = {
  scoreLeadOnCreate: 'ce08b147-cdeb-4202-961a-a45844a4d68b',
  scoreLeadOnUpdate: '78119f3e-4c80-4e1c-b8f6-238f8991f36d',
  qualifyWhatsAppLead: 'eee3dea0-1884-40af-83f1-53419f2f574f',
  answerFromKnowledgeBase: '6f308bd5-42e0-47e9-bff8-fcc6a27ac56e',
  postInstall: '7c7f926d-7f38-4b7a-a980-35bf9f4526dd',
  geminiChat: '28a92135-95f2-4440-9acf-d18909c4661b',
  geminiSmartReply: '52f13710-a975-4e2a-b57f-613cb952d4c1',
  geminiSentiment: '737f95c9-ecc1-457d-8c14-ab10b0eda5fd',
  classifyCallInterest: 'd2c94f81-6a37-4bb5-9e0c-3f71a8d5c264',
  attachTranscriptToSession: '5f8b0a17-3d92-4c65-b7e8-14a06c9d2e3b',
  placeAgentCall: '8e2d47c1-9b03-4f6a-85d2-71c4a90e6b38',
  telephonyConnect: 'a56812cf-45ea-4e5a-a958-7b02eeb53eaa',
  geminiVision: '479c1c29-8e14-44c2-a688-71360b546ff9',
  knowledgeBaseRag: '57cba874-490b-4e70-8bb3-eea5e33c4395',
  twilioPlaceCall: '0a589334-5d24-48a5-b143-b41e5f33e21b',
  twilioStatusCallback: '456ded7c-4cb4-47ab-b741-b1954ce7cedb',
  razorpayPaymentLink: 'f5b6fa30-7141-4990-8910-8439fe5889a3',
  razorpayWebhook: 'a92f58d6-a803-40e3-bd52-0627831c3c65',
  reflectCallOnLead: '31c43f46-a44c-4ca5-a3e8-8113765ee35d',
} as const;

/**
 * Names of the application variables these integrations read from process.env.
 * Values are supplied later from Settings; nothing here holds a credential.
 */
export const INTEGRATION_ENV = {
  geminiApiKey: 'EWINGS_GEMINI_API_KEY',
  geminiModel: 'EWINGS_GEMINI_MODEL',
  twilioAccountSid: 'EWINGS_TWILIO_ACCOUNT_SID',
  twilioAuthToken: 'EWINGS_TWILIO_AUTH_TOKEN',
  twilioFromNumber: 'EWINGS_TWILIO_FROM_NUMBER',
  // Workspace API key. voiceCall belongs to the separate voice application, so
  // an eWings Abroad logic function cannot reach it through the per-application
  // GraphQL client -- the sandbox rejects it with "type `Mutation` does not
  // have a field `createVoiceCall`". The workspace REST/GraphQL endpoint is
  // workspace-wide, so the dispatch route calls it with this key instead.
  workspaceApiKey: 'EWINGS_TWENTY_API_KEY',
  razorpayKeyId: 'EWINGS_RAZORPAY_KEY_ID',
  razorpayKeySecret: 'EWINGS_RAZORPAY_KEY_SECRET',
  razorpayWebhookSecret: 'EWINGS_RAZORPAY_WEBHOOK_SECRET',
} as const;

export const APPLICATION_VARIABLE_IDS = {
  geminiApiKey: 'a670d8e8-8eb3-42c1-ab3a-59dec57a7b17',
  geminiModel: '7a50391d-1800-440c-b575-c92d8514b67a',
  twilioAccountSid: '4ad7b98d-160e-4621-a69c-a54e8a5ff3d9',
  twilioAuthToken: '4fd18bed-8e75-4809-a77b-bfbd084dd4dd',
  twilioFromNumber: '8379e18a-c56b-42eb-a0d9-712d5848c709',
  razorpayKeyId: 'a0d82b7a-c6f9-416d-91ef-e4751760e0b8',
  razorpayKeySecret: '14136773-c805-4e60-8f1e-5cc9fc678a86',
  razorpayWebhookSecret: '0815a4c0-2fb6-4741-9223-f16a93cd8771',
  workspaceApiKey: 'b7e419c3-0d52-4a86-9f37-2c6e08b41da5',
} as const;

export const NAVIGATION_MENU_ITEM_IDS = {
  ewingsFolder: '1ae40dd1-fdbd-4628-8503-054be443d7bb',
  studentLeads: 'dacb4e8a-56de-4251-bedf-9b031b8921b9',
  counsellingSessions: '3fd47c42-2250-4e33-9a91-e736053a6a35',
  universities: '82905fce-be23-43b0-9c52-f11d652eb338',
  knowledgeBase: '3dd1bc0d-7db4-42b5-8cf3-71a97f3b0629',
  desk: '9ed3cade-866d-4e0f-8e11-589304a19886',
  analytics: '3e391473-ea43-49e1-a280-4ad6c47234a9',
  reminders: '7499a0c5-216a-4063-959d-3b76ded5feea',
  inbox: '26b78402-adbe-482a-a047-c05f130bc58e',
  documents: 'ad48ff5c-5778-42b3-a138-4c7857e9977c',
  telephony: 'eed44a3d-d2ee-4d4f-a8c1-a7f5030961a5',
  leadDesk: 'b414a990-2f57-401a-b01d-b23f7a79abf3',
} as const;

/**
 * Call panel: a command-menu front component that dials the selected student
 * lead(s) through the Twilio integration. Availability is RECORD_SELECTION, so
 * the same component serves both the single-row phone action and bulk calling.
 */
export const CALL_PANEL_IDS = {
  frontComponent: '8c437a62-2b5e-43d1-92b0-2857237e3db0',
  commandMenuItem: '98180a87-2f95-4a53-826a-cfbb47dfed58',
} as const;

/** Transcript viewer, opened from a selected Counselling Session. */
export const TRANSCRIPT_VIEWER_IDS = {
  frontComponent: 'f34a7d90-6c28-4b51-8e0d-92b7415ca6f8',
  commandMenuItem: '2d81c6b5-40fa-4e93-b7c1-6a09d385fe27',
} as const;

/**
 * Standalone eWings pages. Each is a front component mounted on its own page
 * layout and linked from the sidebar folder.
 */
export const PAGE_IDS = {
  analytics: {
    frontComponent: '9d5da031-c31a-47f9-b46f-7f9706fed4b5',
    pageLayout: '48407bd4-bf55-414b-b771-c96c42ca2637',
    tab: '5ff94937-9a29-461a-a6c7-66523d59ddf1',
    widget: '86e07bfa-3246-429d-a818-f297f74a34d2',
  },
  reminders: {
    frontComponent: 'de4e450c-e67a-4f9f-9a4f-97c72d9f4ce3',
    pageLayout: 'a84d05b6-0caf-4e89-b7ce-bb5d737809ae',
    tab: 'ee6d7bd5-61ea-49d2-8f9b-4ab73e3472a1',
    widget: 'ba9bf1f0-7275-4ee7-8a6d-f2b99b2819fc',
  },
  inbox: {
    frontComponent: '3521e8fc-a6e9-42bc-8924-0445e6fa613d',
    pageLayout: '060dc61e-ae7c-404c-be08-e9b690889d93',
    tab: '704050b7-1eef-4afa-ab1b-c616e6af7ab0',
    widget: 'a1287b49-5cf5-485c-a270-addd26985e79',
  },
  telephony: {
    frontComponent: '5460907b-d459-4232-927e-3c791d0d2a10',
    pageLayout: '73f0661b-8f71-4c72-a328-bddb330a7707',
    tab: '1cf7c121-301b-4a16-9e7f-8f678eef92d2',
    widget: 'e623c2c2-848d-497e-82f5-46f74854a98a',
  },
  leadDesk: {
    frontComponent: '224f6831-ba8b-40a7-9177-48f32a5069e2',
    pageLayout: 'c166a1b4-c6fe-4c3e-b4d1-1ae3d3047f1b',
    tab: 'd0a85847-da54-4bc6-82f3-fbf56180abe8',
    widget: 'd07fd87f-3220-4913-aed8-c9527a21dc70',
  },
  documents: {
    frontComponent: '1a41e108-f8e4-4288-8b0d-66243f5bee77',
    pageLayout: 'ff3938bb-1777-47e2-95dd-babfe5ce0c28',
    tab: '2b3e121c-9edb-4aa6-a1e1-1f882926c234',
    widget: 'dec67b32-fa05-474c-a087-bb692fe2adba',
  },
} as const;

// Follow-ups the desk owes a student. Created by hand on the Reminders page, or
// automatically from a hot call and from a scheduled agent call.
export const REMINDER_OBJECT_ID = '283f0e5e-9d2a-4b15-b1a6-f1d62138fde8';
export const REMINDER_FIELD_IDS = {
  name: '7c2b86c4-9f86-4aab-91ec-bd35afa3a1d8',
  dueAt: '18f10354-0c6c-4ea3-a93b-06f6b04e292f',
  status: '7329bfea-9fc2-4c3f-88c5-bc0a5f559745',
  priority: '2b952979-ef42-491b-a41f-1094f5eeca49',
  source: '92a66804-2f85-4e85-86cb-d1f73d4da423',
  reason: '68e9db24-ddc7-4da8-b9c7-5282425f7354',
  studentLead: 'ec61154a-9a88-480f-b5c9-d2f9cbba732c',
} as const;

// One document a student has to produce (passport, NEET scorecard, ...). The file
// itself lives in a native FILES field so it uses Twenty's own storage.
export const STUDENT_DOCUMENT_OBJECT_ID = '60679a1b-757c-4e8e-981d-0087be368034';
export const STUDENT_DOCUMENT_FIELD_IDS = {
  name: 'e3c82477-39b7-47a4-9b43-e0f010ee729f',
  kind: 'f508c821-5664-4e72-97ce-602be309f8cb',
  status: '3431bea7-5ce4-4a2a-b481-b4f17cdd59c7',
  file: '2720c305-3419-4a4e-9e1f-7a06c4edd0af',
  notes: '1ec62e1d-2621-4f02-a000-168c254b82a4',
  studentLead: 'aea64ce0-a459-4047-85a2-7749670b1114',
} as const;

/** Set on a counselling session once someone on the desk has read the call. */
export const SESSION_REVIEWED_FIELD_ID = 'b1fe3693-8d2a-4d32-8acf-2fe7adeb1193';

export const FOLLOW_UP_FUNCTION_IDS = {
  remindOnHotCall: '77e7fa5e-c264-450f-9dd2-16acc0af378c',
} as const;

// Web Lead: a raw enquiry from a website form or landing page, before anyone has
// qualified it. Converting one creates a Student Lead and links it back here.
export const WEB_LEAD_OBJECT_ID = 'f1521c4a-5fc8-4085-b664-0d020f19c773';
export const WEB_LEAD_FIELD_IDS = {
  name: 'edf49964-97a3-4009-8d67-76cb4723b6df',
  phone: 'f487fd41-2919-4ee5-86da-653430ec186e',
  email: '7a3efcb9-de64-4694-9757-f48b4a643e23',
  countryInterest: 'aed014e7-7068-437b-8cd6-c687716b3273',
  education: '1bb7f382-2be1-44aa-a1b5-53d349303758',
  message: '1208af25-4e36-4448-a006-819691ecfd97',
  source: '0b0e62fd-01e1-4747-b8c2-adb0eaf30f34',
  submittedAt: 'ba2b1229-eaf0-4d83-b30c-dd47e47beaf0',
  status: '9b3457a5-0271-4707-829e-d8e147578f40',
  convertedLeadId: 'dedecc15-bb9f-4b87-a63c-16aaa35c5400',
  parentName: 'ae9ec96f-a057-41a7-9496-862a8ebd83a0',
  groupInterest: '169f4a65-3b8c-4161-af6f-7db3c63f526b',
  neetQualified: 'b0876474-af33-4d34-9409-3a8355f56e97',
  neetScore: 'cea96b34-e973-4a9c-bc2a-8f979818c2c4',
  gclid: 'c73cb70b-d30b-4ae2-8850-2f5ef5368a36',
  campaignId: '9ebcb3aa-221b-4c71-b3d4-528dad8c3579',
} as const;
